module.exports = __webpack_public_path__ + "static/media/event4.fa6a64ce.jpg";